import {
  CONFIGURATIONS_FETCH,
  CONFIGURATIONS_FETCH_FAILURE,
  CONFIGURATIONS_FETCH_SUCCESS,
  CONFIGURATION_DETAIL_FETCH,
  CONFIGURATION_DETAIL_FETCH_SUCCESS,
  CONFIGURATION_DETAIL_FETCH_FAILURE,
  PAYMENT_METHODS_FETCH,
  PAYMENT_METHODS_FETCH_SUCCESS,
  PAYMENT_METHODS_FETCH_FAILURE,
  CREATE_CONFIGURATION,
  CREATE_CONFIGURATION_FAILURE,
  CREATE_CONFIGURATION_SUCCESS,
  REMOVE_CONFIGURATION,
  REMOVE_CONFIGURATION_SUCCESS,
  REMOVE_CONFIGURATION_FAILURE,
  CONFIGURATION_UPDATE,
  CONFIGURATION_UPDATE_FAILURE,
  CONFIGURATION_UPDATE_SUCCESS,
  OUTLET_FETCH,
  OUTLET_FETCH_FAILURE,
  OUTLET_FETCH_SUCCESS,
  PAYMENT_METHOD_CATEGORIES_FETCH,
  PAYMENT_METHOD_CATEGORIES_FETCH_FAILURE,
  PAYMENT_METHOD_CATEGORIES_FETCH_SUCCESS,
} from './types';

export function fetchOutlets() {
  return {
    type: OUTLET_FETCH,
  };
}

export function fetchOutletsSuccess(outlets) {
  return {
    type: OUTLET_FETCH_SUCCESS,
    payload: {
      outlets,
    },
  };
}

export function fetchOutletsFailure(error) {
  return {
    type: OUTLET_FETCH_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchConfigurations() {
  return {
    type: CONFIGURATIONS_FETCH,
  };
}

export function fetchConfigurationsSuccess(configurations) {
  return {
    type: CONFIGURATIONS_FETCH_SUCCESS,
    payload: {
      configurations,
    },
  };
}

export function fetchConfigurationsFailure(error) {
  return {
    type: CONFIGURATIONS_FETCH_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchConfigurationDetail(configurationId) {
  return {
    type: CONFIGURATION_DETAIL_FETCH,
    payload: {
      configurationId,
    },
  };
}

export function fetchConfigurationDetailSuccess(configurationDetail) {
  return {
    type: CONFIGURATION_DETAIL_FETCH_SUCCESS,
    payload: {
      configurationDetail,
    },
  };
}

export function fetchConfigurationDetailFailure(error) {
  return {
    type: CONFIGURATION_DETAIL_FETCH_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchPaymentMethods() {
  return {
    type: PAYMENT_METHODS_FETCH,
  };
}

export function fetchPaymentMethodsSuccess(paymentMethods) {
  return {
    type: PAYMENT_METHODS_FETCH_SUCCESS,
    payload: {
      paymentMethods,
    },
  };
}

export function fetchPaymentMethodsFailure(error) {
  return {
    type: PAYMENT_METHODS_FETCH_FAILURE,
    error: true,
    payload: error,
  };
}

export function createNewConfiguration(newConfiguration) {
  return {
    type: CREATE_CONFIGURATION,
    payload: {
      newConfiguration,
    },
  };
}

export function createConfigurationFailure(error) {
  return {
    type: CREATE_CONFIGURATION_FAILURE,
    error: true,
    payload: error,
  };
}

export function createConfigurationSuccess(newConfiguration) {
  return {
    type: CREATE_CONFIGURATION_SUCCESS,
    payload: {
      newConfiguration,
    },
  };
}

export function removeConfiguration(configurationId) {
  return {
    type: REMOVE_CONFIGURATION,
    payload: {
      configurationId,
    },
  };
}

export function removeConfigurationSuccess(deletedConfiguration) {
  return {
    type: REMOVE_CONFIGURATION_SUCCESS,
    payload: {
      deletedConfiguration,
    },
  };
}

export function removeConfigurationFailure(error) {
  return {
    type: REMOVE_CONFIGURATION_FAILURE,
    error: true,
    payload: error,
  };
}

export function updateConfiguration(configurationId, patchBody) {
  return {
    type: CONFIGURATION_UPDATE,
    payload: {
      configurationId,
      patchBody,
    },
  };
}

export function updateConfigurationSuccess(configuration) {
  return {
    type: CONFIGURATION_UPDATE_SUCCESS,
    payload: {
      configuration,
    },
  };
}

export function updateConfigurationFailure(error) {
  return {
    type: CONFIGURATION_UPDATE_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchPaymentMethodCategories() {
  return {
    type: PAYMENT_METHOD_CATEGORIES_FETCH,
  };
}

export function fetchPaymentMethodCategoriesSuccess(paymentMethodCategories) {
  return {
    type: PAYMENT_METHOD_CATEGORIES_FETCH_SUCCESS,
    payload: {
      paymentMethodCategories,
    },
  };
}

export function fetchPaymentMethodCategoriesFailure(error) {
  return {
    type: PAYMENT_METHOD_CATEGORIES_FETCH_FAILURE,
    error: true,
    payload: error,
  };
}
